// Brand constants for Voyage Luxe
export const BRAND = {
  name: "Voyage Luxe",
  tagline: "Luxury Journeys Across India & Beyond",
  phone: "+91 95556 47288",
  phone_link: "tel:+919555647288",
  whatsapp: "919555647288",
  whatsapp_link: "https://wa.me/919555647288?text=Hello%20Voyage%20Luxe%2C%20I%20would%20like%20to%20plan%20a%20luxury%20journey.",
  email: "concierge@voyageluxe.com",
  address: "11 Aurangzeb Road, New Delhi 110011, India",
  founded: "MMXVII",
  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    linkedin: "https://linkedin.com/",
    pinterest: "https://pinterest.com/",
  },
};
